import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {TaxFormsActionsCellViewerComponent} from './components/cell-viewers/tax-forms-actions-cell-viewer/tax-forms-actions-cell-viewer.component';
import {FormGridTranslationDialogComponent} from './components/dialogs/form-grid-translation-dialog/form-grid-translation-dialog.component';
import {FormGridCompareDialogComponent} from './components/dialogs/form-grid-compare-dialog/form-grid-compare-dialog.component';
import {TaxFormsNameCellViewerComponent} from './components/cell-viewers/tax-forms-name-cell-viewer/tax-forms-name-cell-viewer.component';
import {FormToolbarCountrylistDialogComponent} from './components/dialogs/form-toolbar-countrylist-dialog/form-toolbar-countrylist-dialog.component';
import { DateRangeDialogComponentComponent } from './components/date-range-dialog-component/date-range-dialog-component.component';
// @dynamic
export class TaxFormsDynamicComponentHelper {
  static components: any;

  static create(): void {
  }

  public static init() {
    if (TaxFormsDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['TaxFormActionCellViewer'] = TaxFormsActionsCellViewerComponent;
    components['FormGridCompareDialogComponent'] = FormGridCompareDialogComponent;
    components['FormGridTranslationDialogComponent'] = FormGridTranslationDialogComponent;
    components['TaxFormsNameCellViewer'] = TaxFormsNameCellViewerComponent;
    components['FormToolbarCountrylistDialogComponent'] = FormToolbarCountrylistDialogComponent;
    components['DateRangeDialogComponentComponent'] = DateRangeDialogComponentComponent;
    TaxFormsDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static getComponentArray(): any[] {
    TaxFormsDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(TaxFormsDynamicComponentHelper.components).forEach(key => {
      componentArray.push(TaxFormsDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
